<template lang="pug">
    section#banner
        div.wrapper
            div.buttons
                button.soualuno(@click="$emit('jasoualuno')") Já sou aluno
                button.querocadastrar(@click="$utils.scrollTo('#inscricao', 130)") Quero me cadastrar
</template>

<script>
export default {
    name: "section-banner"
}
</script>

<style lang="stylus" scoped src="./Banner.styl"></style>